export default {"src":"/_next/static/media/graphic2.10c51f4a.svg","height":160,"width":161,"blurWidth":0,"blurHeight":0};